(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["okko-configuratore-pannello"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(el) {
      if (el.dataset.pronto) return;
      el.dataset.pronto = '1';
      var moduloL = parseInt(el.dataset.moduloL, 10) || 60;
      var moduloA = parseInt(el.dataset.moduloA, 10) || 120;
      var griglia = el.querySelector('[data-conf-griglia]');
      var misura = el.querySelector('[data-conf-misura]');

      function attivo(nome) {
        var b = el.querySelector('[data-conf="' + nome + '"] .okko-configuratore__pillola--attiva');
        return b ? parseInt(b.dataset.valore, 10) : 0;
      }

      function render() {
        var L = attivo('larghezza');
        var A = attivo('altezza');
        if (!L || !A) return;
        var colonne = Math.max(1, Math.round(L / moduloL));
        var righe = Math.max(1, Math.round(A / moduloA));
        griglia.innerHTML = '';
        for (var r = 0; r < righe; r++) {
          var riga = document.createElement('div');
          riga.className = 'okko-configuratore__riga';
          for (var c = 0; c < colonne; c++) {
            var m = document.createElement('div');
            m.className = 'okko-configuratore__modulo';
            riga.appendChild(m);
          }
          griglia.appendChild(riga);
        }
        if (misura) misura.textContent = L + ' × ' + A + ' cm';
      }

      el.addEventListener('click', function (e) {
        var b = e.target.closest('.okko-configuratore__pillola');
        if (!b || !el.contains(b)) return;
        var gruppo = b.closest('.okko-configuratore__pillole');
        gruppo.querySelectorAll('.okko-configuratore__pillola--attiva').forEach(function (x) {
          x.classList.remove('okko-configuratore__pillola--attiva');
        });
        b.classList.add('okko-configuratore__pillola--attiva');
        render();
      });

      render();
    }

    function tutti() {
      document.querySelectorAll('[data-okko-configuratore]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tutti);
    } else {
      tutti();
    }
    document.addEventListener('shopify:section:load', tutti);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["okko-indice-pagina"] && !Shopify.designMode) return;
  try {
    (() => {
    const slug = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'sezione';
    const navi = new Set();

    // id stabile e unico (se il titolo ne ha gia' uno, resta il suo)
    function dammiId(h, base) {
      if (h.id) return h.id;
      let id = base;
      for (let n = 2; document.getElementById(id); n++) id = `${base}-${n}`;
      h.id = id;
      return id;
    }

    function costruisci(nav) {
      const lista = nav.querySelector('[data-okko-indice-lista]');
      const ambito = nav.closest('.custom-section') || document.querySelector('main') || document.body;
      const conSotto = nav.dataset.sottovoci !== 'nessuna';
      const voci = [];
      let marca = null;
      ambito.querySelectorAll('h2, h3').forEach((h) => {
        const testo = h.textContent.trim();
        if (!testo || nav.contains(h) || h.closest('dialog, template')) return;
        if (h.tagName === 'H2' || !marca) {
          marca = { h, id: dammiId(h, slug(testo)), testo, sotto: [] };
          voci.push(marca);
        } else if (conSotto) {
          marca.sotto.push({ h, id: dammiId(h, `${marca.id}-${slug(testo)}`), testo });
        }
      });
      lista.replaceChildren(...voci.map((v) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'okko-indice__voce';
        a.href = `#${v.id}`;
        a.textContent = v.testo;
        li.append(a);
        v.li = li;
        v.a = a;
        if (v.sotto.length) {
          const ol = document.createElement('ol');
          ol.className = 'okko-indice__sotto';
          ol.setAttribute('role', 'list');
          v.sotto.forEach((s) => {
            const sli = document.createElement('li');
            s.a = document.createElement('a');
            s.a.href = `#${s.id}`;
            s.a.textContent = s.testo;
            sli.append(s.a);
            ol.append(sli);
            s.voce = v;
          });
          li.append(ol);
        }
        return li;
      }));
      // in ordine di pagina: marca, le sue serie, la marca dopo...
      nav.okkoTitoli = voci.flatMap((v) => [{ ...v, voce: v }, ...v.sotto]);
      nav.okkoScelto = null;
    }

    function aggiorna(nav) {
      const titoli = nav.okkoTitoli;
      if (!titoli || !titoli.length) return;
      const margine = parseFloat(getComputedStyle(titoli[0].h).scrollMarginTop) || 0;
      let attivo = titoli[0];
      for (const t of titoli) {
        if (t.h.getBoundingClientRect().top - margine <= 12) attivo = t;
        else break;
      }
      // in fondo alla pagina gli ultimi titoli non arrivano in cima: vale quello
      // cliccato se e' a schermo, altrimenti l'ultimo
      if (innerHeight + scrollY >= document.documentElement.scrollHeight - 4) {
        const scelto = nav.okkoScelto;
        const r = scelto && scelto.h.getBoundingClientRect();
        attivo = r && r.top >= 0 && r.bottom <= innerHeight ? scelto : titoli[titoli.length - 1];
      }
      if (nav.okkoAttivo === attivo) return;
      nav.okkoAttivo = attivo;
      titoli.forEach((t) => {
        if (t.li) t.li.classList.toggle('is-attiva', t.li === attivo.voce.li);
        if (t.a) {
          if (t === attivo) t.a.setAttribute('aria-current', 'true');
          else t.a.removeAttribute('aria-current');
        }
      });
      // la voce attiva resta visibile: di lato nella barra, in verticale nella colonna
      const lista = nav.querySelector('[data-okko-indice-lista]');
      const dentro = nav.querySelector('.okko-indice__dentro');
      const voce = attivo.voce.a;
      if (lista.scrollWidth > lista.clientWidth + 1) {
        lista.scrollTo({ left: voce.offsetLeft - (lista.clientWidth - voce.offsetWidth) / 2, behavior: 'smooth' });
      } else if (dentro.scrollHeight > dentro.clientHeight + 1) {
        const a = attivo.a.getBoundingClientRect();
        const d = dentro.getBoundingClientRect();
        if (a.top < d.top || a.bottom > d.bottom) dentro.scrollTop += a.top - d.top - d.height / 3;
      }
    }

    let inAttesa = false;
    function aggiornaTutte() {
      if (inAttesa) return;
      inAttesa = true;
      requestAnimationFrame(() => {
        inAttesa = false;
        navi.forEach((nav) => (nav.isConnected ? aggiorna(nav) : navi.delete(nav)));
      });
    }

    // lo scorrimento si ascolta solo nelle pagine che hanno un indice (il JS dei
    // blocchi sta nel bundle di tutte le pagine)
    let inAscolto = false;
    function ascolta() {
      if (inAscolto) return;
      inAscolto = true;
      addEventListener('scroll', aggiornaTutte, { passive: true });
      addEventListener('resize', aggiornaTutte);
    }

    function avvia(nav) {
      if (nav.dataset.okkoIndicePronto) return;
      nav.dataset.okkoIndicePronto = '1';
      costruisci(nav);
      navi.add(nav);
      ascolta();
      nav.addEventListener('click', (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const t = (nav.okkoTitoli || []).find((x) => x.id === a.hash.slice(1));
        if (!t) return;
        e.preventDefault();
        nav.okkoScelto = t;
        const calma = matchMedia('(prefers-reduced-motion: reduce)').matches;
        t.h.scrollIntoView({ behavior: calma ? 'instant' : 'smooth', block: 'start' });
        history.replaceState(null, '', a.hash);
        aggiornaTutte(); // gia' in fondo la pagina non scorre: nessun evento scroll
        if (!t.h.hasAttribute('tabindex')) t.h.setAttribute('tabindex', '-1');
        t.h.focus({ preventScroll: true });
      });
      // aperta con #marca: gli id esistono solo ora, quindi lo scorrimento lo fa il JS
      const daHash = location.hash && (nav.okkoTitoli || []).find((x) => `#${x.id}` === decodeURIComponent(location.hash));
      if (daHash) daHash.h.scrollIntoView({ behavior: 'instant', block: 'start' });
      aggiorna(nav);
    }

    const tutte = () => document.querySelectorAll('[data-okko-indice]').forEach(avvia);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
    else tutte();
    // nell'editor la sezione si ridisegna a ogni modifica: l'indice si ricostruisce
    document.addEventListener('shopify:section:load', tutte);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["okko-loop-lista"] && !Shopify.designMode) return;
  try {
    // Monta le colonne dell'"Elenco a lista": ordina/filtra i td server-rendered
  // (data-okko-colonna) secondo le <th> dei blocchi figli (data-okko-lcol).
  // Solo spostamenti di nodi: i listener del tema sono delegati, nulla si rompe.
  (() => {
    const monta = () => {
      document.querySelectorAll('[data-okko-loop-lista]').forEach((lista) => {
        // due Colonne metafield: la prima usa la chiave 1, la seconda la chiave 2
        let nMf = 0;
        const ordine = [...lista.querySelectorAll('thead [data-okko-lcol]')]
          .map((th) => {
            let tipo = th.dataset.okkoLcol;
            if (tipo === 'metafield') {
              nMf += 1;
              if (nMf > 1) tipo = 'metafield2';
            }
            return tipo;
          });
        lista.querySelectorAll('tbody tr').forEach((tr) => {
          const celle = {};
          tr.querySelectorAll('[data-okko-colonna]').forEach((td) => {
            celle[td.dataset.okkoColonna] = td;
            td.remove();
          });
          ordine.forEach((tipo) => { if (celle[tipo]) tr.appendChild(celle[tipo]); });
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', monta);
    } else {
      monta();
    }
    document.addEventListener('shopify:section:load', monta);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["okko-modelli-serie"] && !Shopify.designMode) return;
  try {
    (() => {
    const T = {
      richiesta: 'su richiesta',
      unoModale: '1 articolo disponibile',
      piuModale: '[n] articoli disponibili',
      caricamento: 'Carico i prodotti…',
      vuoto: 'Nessun articolo per questo modello.',
      errore: 'Non sono riuscito a caricare i prodotti.',
      oltre: 'Qui i primi [n]: gli altri nel catalogo.',
      apri: 'Apri nel catalogo',
      chiudi: 'Chiudi',
    };

    /* --- Modale coi prodotti del modello ----------------------------------
       Righe dalla vista ?view=righe dell'URL della card (le stesse del
       catalogo), poi bozza ridipinta sulle righe, Salvati, Avvisami e prezzi
       BSS (il ponte non osserva i dialog: va richiamato). La risposta resta in
       memoria per la vita della pagina. Il dialog e' uno solo, creato al primo
       clic; stile in okko-b2b.css (.okko-righe-modale). */
    const LIMITE = 250; // paginate della vista
    const cache = new Map();
    let dlg = null;
    let ctrl = null;

    function modale() {
      if (dlg) return dlg;
      const x = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7"/></svg>';
      const tpl = document.createElement('template');
      tpl.innerHTML = `<dialog class="okko-draft-modal okko-righe-modale" aria-labelledby="OkkoRigheTitolo">
        <div class="okko-draft-modal__head">
          <h2 class="okko-draft-modal__title" id="OkkoRigheTitolo"><span data-okko-righe-titolo></span> <small data-okko-righe-conta></small></h2>
          <button type="button" class="okko-draft-modal__close" data-okko-righe-chiudi aria-label="${T.chiudi}">${x}</button>
        </div>
        <div class="okko-righe-modale__corpo" data-okko-righe-corpo></div>
        <div class="okko-draft-modal__foot okko-draft-modal__foot--bar">
          <a class="okko-righe-modale__catalogo" href="/collections/all" data-okko-righe-catalogo>${T.apri} &rarr;</a>
          <button type="button" class="okko-btn okko-btn--ghost" data-okko-righe-chiudi>${T.chiudi}</button>
        </div>
      </dialog>`;
      dlg = tpl.content.firstElementChild;
      document.body.appendChild(dlg);
      dlg.addEventListener('click', (e) => {
        // velo (il click fuori dal contenuto arriva al dialog stesso), X o Chiudi
        if (e.target === dlg || e.target.closest('[data-okko-righe-chiudi]')) dlg.close();
      });
      // chiusura da X, Chiudi, velo o Esc: richiesta viva annullata e bozza
      // ridipinta (totale della barra in pagina compreso)
      dlg.addEventListener('close', () => {
        if (ctrl) { ctrl.abort(); ctrl = null; }
        if (window.OKKO && window.OKKO.restoreDraft) window.OKKO.restoreDraft();
      });
      return dlg;
    }

    function stato(testo, href) {
      const p = document.createElement('p');
      p.className = 'okko-righe-modale__stato';
      p.textContent = testo;
      if (href) {
        const a = document.createElement('a');
        a.href = href;
        a.textContent = T.apri;
        p.append(' ', a);
      }
      return p;
    }

    // righe della vista ?view=righe per l'URL di una card (o il suo ripiego)
    async function leggiRighe(href, segnale) {
      const u = new URL(href, location.origin);
      u.searchParams.set('view', 'righe');
      const url = u.pathname + u.search;
      let html = cache.get(url);
      if (!html) {
        const res = await fetch(url, { signal: segnale, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error(`righe ${res.status}`);
        html = await res.text();
        cache.set(url, html);
      }
      return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-okko-righe]');
    }

    const quante = (righe) => (righe ? Number(righe.dataset.okkoRigheN) || 0 : 0);

    async function apri(card) {
      const d = modale();
      const nome = card.querySelector('.okko-modelli__nome');
      const conta = d.querySelector('[data-okko-righe-conta]');
      const corpo = d.querySelector('[data-okko-righe-corpo]');
      const catalogo = d.querySelector('[data-okko-righe-catalogo]');
      d.querySelector('[data-okko-righe-titolo]').textContent = nome ? nome.textContent.trim() : '';
      catalogo.href = card.href;
      conta.textContent = '';
      corpo.replaceChildren(stato(T.caricamento));
      d.setAttribute('aria-busy', 'true');
      d.showModal();

      if (ctrl) ctrl.abort();
      const mio = new AbortController();
      ctrl = mio;
      let href = card.href;
      let esauriti = false;
      let righe;
      try {
        righe = await leggiRighe(href, mio.signal);
        // nessun disponibile: lo stesso modello senza "Solo disponibili"
        if (!quante(righe) && card.dataset.hrefTutti) {
          href = card.dataset.hrefTutti;
          esauriti = true;
          righe = await leggiRighe(href, mio.signal);
        }
      } catch (err) {
        if (mio.signal.aborted) return; // chiusa, o superata da un'altra card
        corpo.replaceChildren(stato(T.errore, href));
        d.removeAttribute('aria-busy');
        return;
      }
      if (mio !== ctrl || !d.open) return;
      ctrl = null;

      const n = quante(righe);
      catalogo.href = href;
      d.removeAttribute('aria-busy');
      if (!n) {
        corpo.replaceChildren(stato(T.vuoto, href));
        return;
      }
      conta.textContent = esauriti
        ? T.richiesta
        : (n === 1 ? T.unoModale : T.piuModale.replace('[n]', n));
      corpo.replaceChildren(...righe.childNodes);
      if ((Number(righe.dataset.okkoRighePagine) || 0) > 1) {
        const nota = stato(T.oltre.replace('[n]', LIMITE), href);
        nota.className = 'okko-righe-modale__nota';
        corpo.append(nota);
      }
      const O = window.OKKO || {};
      if (O.restoreDraft) O.restoreDraft();
      if (O.paintWishlist) O.paintWishlist();
      if (O.paintBis) O.paintBis();
      if (O.bss && O.bss.aggiorna) O.bss.aggiorna();
    }

    // Clic semplice sulla card = modale. Cmd/Ctrl/Shift/Alt o tasto centrale
    // lasciano fare al link (catalogo, anche in una scheda nuova). Nell'editor
    // il clic serve a selezionare il blocco Modello: niente modale.
    document.addEventListener('click', (e) => {
      if (window.Shopify && window.Shopify.designMode) return;
      const card = e.target.closest('[data-okko-modelli] a.okko-modelli__card');
      if (!card || e.defaultPrevented) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (typeof HTMLDialogElement !== 'function') return;
      e.preventDefault();
      apri(card);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
